// SPDX-FileCopyrightText: 2026 Povl Filip Sonne-Frederiksen
//
// SPDX-License-Identifier: GPL-3.0-or-later

/**
 * The BIM import jobs this page started (Importér BIM-model). The Ground
 * frames the model only after an import of its own — another client's
 * import refreshes the model but leaves this user's camera alone. A page
 * load is a new session, so a module-level set is the whole store.
 */

const own = new Set<string>();

/** The dialog submitted job `id` (its 202 answer). */
export function markOwnImport(id: string): void {
  own.add(id);
}

export function isOwnImport(id: string): boolean {
  return own.has(id);
}
